<template>
    <div v-if="mobileCheck || windowWidth < 768" class="home-wine-market">
        <div class="mobile-wines-body">
            <div style="display: none">{{onlyEnPrimeurWines}}</div>
            <div class="mobile-wines-row" v-for="(item, index) in enPrimeurArray" :key="index" v-if="onlyEnPrimeurWines.length">
                <div v-if="item.displayWineName">
                    <div class="mobile-wines-name" v-on:click="() => { goToWineDetails(item) }">{{ item.displayWineName }}</div>
                </div>
                <div v-else-if="item.wineName">
                    <div class="mobile-wines-name" v-on:click="() => { goToWineDetails(item) }">{{ item.wineName }}</div>
                </div>
                <div v-else>
                    <div class="mobile-wines-name" v-on:click="() => { goToWineDetails(item) }">{{ item.vintage }} {{ item.producerName }}</div>
                </div>
                <div v-if="item.isEnPrimeur" class="wine-enprimeur-mobile">En Primeur</div>
                <div class="mobile-wines-inner-row">
                    <div class="country-flag" :style="{ background: `url(${item.countryFlagUrl}) no-repeat center` }"></div>
                    <div class="mobile-wines-vintage">{{ item.regionName }}, {{item.appellation}}</div>
                </div>
                <div class="mobile-wines-inner-row mobile-wines-inner-row-colour">
                    <div class="mobile-wines-div mobile-wines-label">{{ $t('colour') }}</div>
                    <div class="mobile-wines-div mobile-wines-value">
                        <div class="winemarket-winecolor-img winemarket-winecolor-img-m" :class="item.colorId == 1 ? 'redwine' : (item.colorId == 2 ? 'whitewine' : 'champagne')" ></div>
                        <div class="winecolor-tooltip">{{item.colorId == 1 ? $t('red') : (item.colorId == 2 ? $t('white') : (item.colorId == 3 ? $t('rose') : $t('champagne')))}}</div>
                    </div>
                </div>
                <div class="mobile-wines-inner-row">
                    <div class="mobile-wines-div mobile-wines-label">{{ $t('case-size') }}</div>
                    <div class="mobile-wines-div mobile-wines-value">
                        {{ item.size }}l
                    </div>
                </div>
                <div class="mobile-wines-inner-row">
                    <div class="mobile-wines-div mobile-wines-label">Best sell</div>
                    <div class="mobile-wines-div mobile-wines-value">
                        {{ formatPrice(item.sellPrice.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) }}
                    </div>
                </div>
                <div class="mobile-wines-inner-row">
                    <div class="mobile-wines-div mobile-wines-label">Best buy</div>
                    <div class="mobile-wines-div mobile-wines-value">
                        {{ formatPrice(item.buyPrice.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) }}
                    </div>
                </div>
                <div class="mobile-wines-inner-row">
                    <div class="mobile-wines-div mobile-wines-label">Last trade</div>
                    <div class="mobile-wines-div mobile-wines-value">
                        <div class="mobile-wines-inner-row-last-trade">{{ item.lastTradePrice == null ? '-' : formatPrice(item.lastTradePrice.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) }}</div>
                        <div class="winemarket-change winemarket-change-m" :class="item.change > -1 ? 'positive' : (item.change == null ? '' : 'negative')">
                            {{ item.change == null ? '0.00%' : `${item.change.toFixed(2)}%` }}
                            <div></div>
                        </div>
                    </div>
                </div>
                <div class="mobile-wines-inner-row mobile-wines-inner-row-fav">
                    <div class="mobile-wines-div mobile-wines-label">Favourites</div>
                    <div class="mobile-wines-div mobile-wines-value">
                        <button v-on:click="(event) => toggleFav(event, item)" :class="item.isFavourite ? 'wine-star wine-star-m active' : 'wine-star wine-star-m'"></button>
                    </div>
                </div>
                <div class="mobile-wines-inner-row">
                    <div class="mobile-wines-div">
                        <button class="btn-secondary market-btn" v-on:click="() => selectWine(item, false)" :disabled="checkWineSell(item)">{{ $t('sell') }}</button>
                    </div>
                    <div class="mobile-wines-div mobile-wines-value">
                        <div class="btn-secondary market-btn ga4-buy-wine" v-on:click="() => selectWine(item, true)">{{ $t('buy') }}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else>
        <v-data-table :headers="headers" :items="enPrimeurArray" v-if="onlyEnPrimeurWines.length" :items-per-page="7" hide-default-footer fixed-header class="winemarket-table-home">
            <template v-slot:item="{ item }">
                <tr>
                    <td class="wineitemhome-td">
                        <div class="country-flag" :style="{ background: `url(${item.countryFlagUrl}) no-repeat center` }"></div>
                        <div v-if="item.displayWineName">
                            <div class="wine-vintage-name" v-on:click="() => { goToWineDetails(item) }">{{ item.displayWineName }}</div>
                        </div>
                        <div v-else-if="item.wineName">
                            <div class="wine-vintage-name" v-on:click="() => { goToWineDetails(item) }">{{ item.vintage }} {{ item.wineName }}</div>
                        </div>
                        <div v-else>
                            <div class="wine-vintage-name" v-on:click="() => { goToWineDetails(item) }">{{ item.vintage }} {{ item.producerName }}</div>
                        </div>
                        <div v-if="item.isEnPrimeur" class="wine-enprimeur">En Primeur</div>
                    </td>
                    <td class="region-td">
                        {{ item.regionName }}, {{item.appellation}}
                    </td>
                    <td class="color-td text-right">
                        <div class="winemarket-winecolor-img" :class="item.colorId == 1 ? 'redwine' : (item.colorId == 2 ? 'whitewine' : 'champagne')" ></div>
                        <div class="winecolor-tooltip">{{item.colorId == 1 ? $t('red') : (item.colorId == 2 ? $t('white') : (item.colorId == 3 ? $t('rose') : $t('champagne')))}}</div>
                    </td>
                    <td class="winesize-td text-right">
                        {{ item.size }}l
                        <div>&nbsp;</div>
                    </td>
                    <td class="best-buy text-right best-sell-th">
                        {{ formatPrice(item.sellPrice.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) }}
                        <div>&nbsp;</div>
                    </td>
                    <td class="best-buy text-right best-buy-th">
                        {{ formatPrice(item.buyPrice.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) }}
                        <div>&nbsp;</div>
                    </td>
                    <td class="wine-last-traded-price text-right">
                        {{ item.lastTradePrice == null ? '-' : formatPrice(item.lastTradePrice.toLocaleString("fi-FI", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(',','.')) }}
                        <div class="winemarket-change" :class="item.change > -1 ? 'positive' : (item.change == null ? '' : 'negative')">
                            {{ item.change == null ? '0.00%' : `${item.change.toFixed(2)}%` }}
                            <div></div>
                        </div>
                    </td>
                    <!--                    <td>-->
                    <!--                        <button class="wine-star"></button>-->
                    <!--                    </td>-->
                    <td class="market-btn-col half-padding-right">
                        <button class="btn-secondary market-btn" v-on:click="() => selectWine(item, false)" :disabled="checkWineSell(item)">{{ $t('sell') }}</button>
                    </td>
                    <td class="market-btn-col half-padding-left no-padding-right">
                        <div class="btn-secondary market-btn ga4-buy-wine" v-on:click="() => selectWine(item, true)">{{ $t('buy') }}</div>
                    </td>
                </tr>
            </template>

            <template slot="no-data">
                <v-alert dense type="info" class="no-orders-info">There are no wines found based on your criteria.</v-alert>
            </template>
        </v-data-table>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import {AWines, APortfolio, AMarket} from '@/store/actions';
import {GMarket, GPortfolio, GWines} from '@/store/getters';
import {GCommon,GUser} from "@/store/getters";

export default {
    name: "WineMarketHome",
    props: ['enPrimeur'],
    data() {
        return {
            headers: [
                { text: 'Wine', value: 'producerName', class: 'wine-th' },
                { text: 'Region', value: 'regionName' },
                { text: 'Colour', align: 'right', value: 'colorId' },
                { text: this.$i18n.t('case-size'), align: 'right', value: 'size' },
                { text: 'Best sell', align: 'right', value: 'units', class: 'best-sell-th' },
                { text: 'Best buy', align: 'right', value: 'price', class: 'best-buy-th' },
                { text: 'Last trade', align: 'right', value: 'lastTradePrice' },
                // { text: 'Favourites', align: 'center', value: 'isFavourite' },
                { text: '', value: 'buyWine' },
                { text: '', value: 'sellWine' }
            ],
            windowWidth: null,
            enPrimeurArray: [],
            loginLink: '/trading-desk',
            filtersObj: {
                vintage: null,
                countryId: null,
                regionId: null,
                appellationId: null,
                producerId: null,
                colorId: null,
                priceFrom: null,
                priceTo: null,
                isEnPrimeur: ''
            }
        }
    },
    computed: {
        ...mapGetters({
            wineItems: GMarket.GET_WINES,
            portfolioSummary: GPortfolio.GET_PORTFOLIO_SUMMARY,
            favWinesList: GWines.GET_FAVOURITE_WINES,
            mobileCheck: GCommon.GET_MOBILE_VERSION,
            isLogged: GUser.GET_USER_LOGGED
        }),
        onlyEnPrimeurWines() {
            if (this.enPrimeur) {
                let _winesList = [];
                this.wineItems.forEach(wine => {
                    if (wine.isEnPrimeur) {
                        _winesList.push(wine)
                    }
                });
                this.enPrimeurArray = _winesList.slice(0,15);
                return _winesList.slice(0,15);
            } else {
                this.enPrimeurArray = this.wineItems.slice(0,15);
                return this.wineItems.slice(0,15);
            }
        }
    },
    methods: {
        ...mapActions({
            getWines: AMarket.GET_WINES
        }),
        formatPrice(price) {
            return `€ ${price}`
        },
        selectWine(item, isBuy) {
            if (!this.isLogged) {
                this.loginLink = '/wine-details/' + item.wineId + '/' + item.caseSizeId + '/' + item.appellation.toLowerCase().split(' ').join('-') + '-' + (item.classification ? item.classification.toLowerCase().split(' ').join('-') : '') + '-' + (item.colorId === 1 ? 'red' : (item.colorId === 2 ? 'white' : (item.colorId === 3 ? 'rose' : 'champagne'))) + '-' + item.vintage + '-' + item.producerName.toLowerCase().split(' ').join('-');
                this.$nuxt.$emit("showLoginModal", '');
            } else {
                this.$store.dispatch(AWines.SELECT_WINE_ID, { wineId: item.wineId, caseSize: item.caseSizeId, languageId: this.$i18n.locale });
                this.$store.dispatch(AWines.GET_WINE_DETAILS);
                this.$router.push(this.localePath({ path: (isBuy ? '/wine-trading-buy/' : '/wine-trading-sell/') + item.wineId }));
            }
        },
        toggleFav(event, wine) {
            event.stopPropagation();
            let currWineId = wine.wineId;
            let currWineCaseSizeId = wine.caseSizeId;
            this.$store.dispatch(AWines.SWITCH_WINE_FAVOURITE, {wineId: wine }).then(x => {
                this.$store.dispatch(AWines.GET_FAVOURITE_WINES).then(
                    this.enPrimeurArray.forEach(wine => {
                        if (wine.wineId === currWineId) {
                            let isWineInFavourites = false;
                            this.favWinesList.forEach(wine => {
                                if (currWineId === wine.wineId && currWineCaseSizeId === wine.caseSizeId) {
                                    isWineInFavourites = true;
                                }
                            });
                            wine.isFavourite = isWineInFavourites;
                            return true
                        }
                    })
                )
            });
        },
        goToWineDetails(item) {
            if (!this.isLogged) {
                this.$store.dispatch(AWines.GET_WINE_DETAILS_NOT_LOGGED, { wineId: item.wineId, caseSize: item.caseSizeId, languageId: this.$i18n.locale }).then(() => {
                    this.$router.push(this.localePath({ path: '/wine-details/' + item.wineId + '/' + item.appellation.toLowerCase().split(' ').join('-') + '-' + (item.classification ? item.classification.toLowerCase().split(' ').join('-') : '') + '-' + (item.colorId === 1 ? 'red' : (item.colorId === 2 ? 'white' : (item.colorId === 3 ? 'rose' : 'champagne'))) + '-' + item.vintage + '-' + item.producerName.toLowerCase().split(' ').join('-') }));
                });
            } else {
                this.wineId = item.wineId;
                this.$store.dispatch(AWines.SELECT_WINE_ID, { wineId: item.wineId, caseSize: item.caseSizeId, languageId: this.$i18n.locale }).then(() => {
                    this.$store.dispatch(AWines.GET_WINE_DETAILS).then(() => {
                        this.$router.push(this.localePath({ path: '/wine-details/' + item.wineId + '/' + item.caseSizeId + '/' + item.appellation.toLowerCase().split(' ').join('-') + '-' + (item.classification ? item.classification.toLowerCase().split(' ').join('-') : '') + '-' + (item.colorId === 1 ? 'red' : (item.colorId === 2 ? 'white' : (item.colorId === 3 ? 'rose' : 'champagne'))) + '-' + item.vintage + '-' + item.producerName.toLowerCase().split(' ').join('-') }));
                    });
                })
            }
        },
        goToLogin() {
            localStorage.setItem('login_path', this.loginLink);
            this.$router.push(this.localePath({ path: '/login' }));
        },
        goToRegister() {
            this.$router.push(this.localePath({ path: '/register' }));
        },
        checkWineSell(wineObj) {
            if (!this.isLogged) {
                return true
            } else {
                let isSellAvailable = true;
                this.portfolioSummary.forEach(wine => {
                    if (wine.wineId === wineObj.wineId && wine.caseSizeId === wineObj.caseSizeId) {
                        isSellAvailable = false;
                    }
                });
                return isSellAvailable
            }
        }
    },
    mounted() {
        this.windowWidth = window.innerWidth;
        this.filtersObj.isEnPrimeur = this.enPrimeur ? true : '';
        this.getWines(this.filtersObj);

        if (this.isLogged) {
            this.$store.dispatch(AWines.GET_FAVOURITE_WINES).then(
                this.enPrimeurArray.forEach(wine => {
                    if (wine.wineId === currWineId) {
                        let isWineInFavourites = false;
                        this.favWinesList.forEach(wine => {
                            if (currWineId === wine.wineId && currWineCaseSizeId === wine.caseSizeId) {
                                isWineInFavourites = true;
                            }
                        });
                        wine.isFavourite = isWineInFavourites;
                        return true
                    }
                })
            );
            this.$store.dispatch(APortfolio.GET_PORTFOLIO_SUMMARY);
        }
    }
}
</script>

<style scoped>
.mobile-wines-body {
    overflow: hidden;
    padding: 0 15px;
}
.home-wine-market {
    margin: 0 -15px;
}
.mobile-wines-inner-row-last-trade {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-style: normal;
    font-weight: bold;
    font-size: 19px;
    line-height: 120%;
    color: #000000;
}
.mobile-wines-name {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-size: 19px;
    line-height: 23px;
    color: #404040;
    font-weight: 600;
}
.mobile-wines-name:hover {
    color: var(--brand);
    cursor: pointer;
}
.mobile-wines-inner-row {
    margin: 4px auto 8px;
}
.mobile-wines-vintage {
    display: inline-block;
    font-family: Roboto, sans-serif;
    font-size: 14px;
    line-height: 23px;
    color: #000000;
    font-style: normal;
    font-weight: normal;
}
.mobile-wines-label {
    font-family: Roboto, sans-serif;
    font-size: 14px;
    line-height: 160%;
    text-align: left;
    color: #B2B2B2;
    font-style: normal;
    font-weight: normal;
}
.mobile-wines-inner-row-fav {
    margin-bottom: 20px;
}
.mobile-wines-inner-row-fav .mobile-wines-label {
    line-height: 33px;
}
.mobile-wines-value {
    font-family: Roboto, sans-serif;
    font-size: 14px;
    line-height: 160%;
    text-align: right;
    color: #000000;
    font-style: normal;
    font-weight: normal;
}
.mobile-wines-row {
    padding: 15px 0;
    border-bottom: 1px solid #CCCCCC;
}
.mobile-wines-div {
    display: inline-block;
    width: calc(50% - 2px);
    vertical-align: top;
}
.mobile-wines-inner-row-colour .mobile-wines-div {
    line-height: 24px;
}
.mobile-line {
    line-height: 20px;
}
.winemarket-table-home {
    margin-bottom: 32px;
}
.country-flag {
    width: 25px;
    height: 15px;
    background-size: contain !important;
    display: block;
    top: 17px;
    position: absolute;
}
.mobile-wines-div .country-flag {
    top: 2px
}
.region-td {
    width: 130px;
}
.wine-vintage-name {
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-weight: 700;
    font-size: 14px;
    line-height: 17px;
    text-indent: 30px;
}
.wine-vintage-name:hover {
    cursor: pointer;
}
.wineitemhome-td {
    width: 200px;
    position: relative;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-left: 0 !important;
}
.wine-enprimeur {
    background: #CEA94B;
    text-align: center;
    width: 60px;
    height: 16px;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 10px;
    line-height: 9px;
    color: #FFFFFF;
    padding: 4px;
    position: absolute;
    bottom: 5px;
}
.wine-enprimeur-mobile {
    background: #CEA94B;
    text-align: center;
    width: 84px;
    height: 25px;
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    color: #FFFFFF;
    padding: 4px;
    margin-top: 10px;
    margin-bottom: 10px;
}
.mobile-wines-div.wineitemhome-td,
.mobile-wines-div.region-td {
    width: 50%;
    height: 40px;
    vertical-align: top;
    line-height: 20px;
}
.winemarket-winecolor-img {
    height: 17px;
    width: 9px;
    display: inline-block;
    position: relative;
    background: url('../assets/rose.png') no-repeat center right;
    background-size: contain;
    margin-right: 8px;
    top: 2px;
}
.winemarket-winecolor-img.redwine {
    background: url('../assets/red.png') no-repeat center right;
    background-size: contain;
}
.winemarket-winecolor-img.whitewine {
    background: url('../assets/white.png') no-repeat center right;
    background-size: contain;
}
.winemarket-winecolor-img-m {
    margin-left: 10px;
    height: 15px;
}
.winecolor-tooltip {
    display: inline-block;
}
.wine-last-traded-price {
    font-weight: 700 !important;
    line-height: 23px;
    padding-left: 0 !important;
    padding-right: 0 !important;
}
.wine-last-traded-price-m {
    line-height: 20px;
    position: relative;
}
.best-buy {
    padding-left: 0 !important;
}
.best-buy.mobile-wines-div {
    vertical-align: initial;
    line-height: 40px;
}
.winemarket-change {
    color: #b2b2b2;
    font-size: var(--fs-small);
    margin: 2px 0;
    font-weight: normal;
}
.winemarket-change-m {
    margin: 0;
}
.winemarket-change.negative div {
    width: 10px;
    height: 15px;
    background-size: contain;
    display: inline-block;
    top: 1px;
    position: relative;
    background: url('../assets/price-low-10px.svg') no-repeat center;
}
.winemarket-change.positive div {
    width: 10px;
    height: 15px;
    background-size: contain;
    display: inline-block;
    top: 1px;
    position: relative;
    background: url('../assets/price-up-10px.svg') no-repeat center;
}
.wine-star {
    background: url('../assets/home/star.png') no-repeat center;
    width: 24px;
    height: 24px;
    display: block;
    margin: 0 auto;
    background-size: contain;
}
.wine-star:focus,
.wine-star:active {
    outline: none;
}
.wine-star.active,
.wine-star:hover {
    background: url('../assets/star-selected.svg') no-repeat center;
    background-size: contain;
}
.wine-star.active:hover {
    opacity: 0.8;
}
.market-btn {
    min-width: 95px;
    font-weight: 300;
    text-align: center;
    line-height: 25px;
    height: 40px;
}
.market-btn-col {
    width: 100px;
}
.half-padding-right {
    padding-right: 8px;
    padding-left: 25px;
}
.half-padding-left {
    padding-left: 8px;
}
.no-padding-right {
    padding-right: 0;
}
.bids-offers-modal h3 {
    margin-bottom: 16px;
    font-size: var(--fs-large);
}
.btn-bid-proceed {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
    background: var(--brand);
    color: #ffffff;
}
.btn-login {
    background: #004f7f;
    border-color: #004f7f;
}
.btn-bid-cancel {
    font-size: var(--fs-base);
    text-transform: initial;
    font-weight: 300;
    padding: 0 20px !important;
}
.btn-bid-cancel:hover {
    color: #ffffff;
}
.bids-offers-modal {
    padding: 32px 48px;
    text-align: center;
    background: #f6f6f6;
}
.bids-offers-modal .warning-icon {
    background: url('../assets/report_problem-24px.svg') no-repeat center;
    background-size: contain;
    width: 40px;
    height: 40px;
    margin: 0 auto;
}
.bids-title svg {
    margin-right: 5px;
    fill: #707070;
}
.offers-title svg {
    margin-right: 5px;
    fill: #707070;
}
.cancel-bid-body {
    text-align: center;
    justify-content: center;
    font-size: var(--fs-base);
}
.winemarket-winecolor-img-m {
    margin-left: 10px;
    margin-right: 10px;
    height: 15px;
    display: inline-block;
    width: 10px;
}
.wine-last-traded-price-m {
    line-height: 20px;
    position: relative;
}
.wine-star-m {
    float: right;
}

@media (width: 1024px) {
    .best-sell-th,
    .best-buy-th {
        display: none;
    }
}

@media (max-width: 767px) {
    .btn-bid-proceed {
        padding: 0 5px !important;
    }
    .country-flag {
        display: inline-block;
        width: 21px;
        height: 12px;
        position: relative;
        top: 0;
        margin-right: 7px;
        background-size: contain !important;
    }
    .winecolor-tooltip {
        display: inline-block;
        font-family: Roboto, sans-serif;
        font-size: 14px;
        line-height: 160%;
        font-style: normal;
        font-weight: normal;
        color: #000000
    }
    .winemarket-change {
        font-family: Roboto, sans-serif;
        font-size: 16px;
        line-height: 160%;
        font-style: normal;
        font-weight: normal;
        color: #B2B2B2;
    }
    .market-btn {
        width: calc(100% - 8px);
    }
}
</style>

<style>
.bids-offers-modal .v-card__title,
.bids-offers-modal .v-card__actions{
    justify-content: center;
}
.theme--light.v-data-table.winemarket-table-home tbody tr {
    padding-top: 16px;
    padding-bottom: 16px;
    height: 74px;
    vertical-align: top;
    border-bottom: 1px solid #cccccc;
}
.theme--light.v-data-table.winemarket-table-home tbody tr:hover td {
    background: white;
}
.v-data-table.winemarket-table-home td {
    padding-top: 16px !important;
    font-family: 'Montserrat', Arial, Helvetica, sans-serif;
    font-weight: 400;
    font-size: 12px !important;
    color: #000000
}
.v-data-table.winemarket-table-home td.color-td {
    padding-left: 0;
    padding-right: 0;
}
.theme--light.v-data-table.v-data-table--fixed-header.winemarket-table-home thead th {
    color: #b2b2b2 !important;
    font-size: var(--fs-small);
    font-weight: 300;
    box-shadow: none !important;
    height: 50px;
    padding-top: 20px;
    white-space: nowrap;
}
.theme--light.v-data-table.v-data-table--fixed-header.winemarket-table-home thead th.wine-th {
    padding-left: 0;
}

@media (width: 1024px) {
    .theme--light.v-data-table.v-data-table--fixed-header.winemarket-table-home thead th.best-sell-th,
    .theme--light.v-data-table.v-data-table--fixed-header.winemarket-table-home thead th.best-buy-th {
        display: none;
    }
}
</style>
